<template>
    <canvas
        :width="image.width"
        :height="image.height"
        :style="style"
    />
</template>

<script>
export default {
    name: 'Canvas',
    props: {
        canvas: {
            required: true,
            validator(value) {
                return typeof value === 'boolean' || typeof value === 'object';
            }
        },
        ctx: {
            required: true,
            validator(value) {
                return typeof value === 'boolean' || typeof value === 'object';
            }
        },
        setCanvas: {
            type: Function,
            required: true
        },
        setCtx: {
            type: Function,
            required: true
        },
        originalImage: {
            type: HTMLImageElement,
            required: true
        },
        image: {
            type: Object,
            required: true
        },
        scale: {
            type: Object,
            required: true
        },
        pushStack: {
            type: Function,
            required: true
        }
    },
    computed: {
        img() {
            return this.originalImage;
        },
        style() {
            return {
                top: `${this.scale.top}px`,
                left: `${this.scale.left}px`,
                transform: `scale(${this.scale.scale})`
            };
        }
    },
    watch: {
        img() {
            this.drawImage();
        }
    },
    mounted() {
        this.setCanvas(this.$el);
        this.setCtx(this.$el.getContext('2d'));

        this.$nextTick()
            .then(() => {
                this.drawImage();
            });
    },
    methods: {
        drawImage() {
            this.ctx.drawImage(this.img, 0, 0, this.image.width, this.image.height);
            this.imageData = this.ctx.getImageData(0, 0, this.image.width, this.image.height);
            // @NOTE should this clear the stack?
            this.pushStack(this.imageData);
        }
    }
};
</script>

<style lang="scss" scoped>
@keyframes fadein {
    from {
        opacity: 0
    }
    to {
        opacity: 1
    }
}

canvas {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;
    animation: fadein .3s;
    border: 0;
}
</style>
